import React, { useState } from "react"
import { DatePicker } from "@lrewater/lre-react"
import LreReactLayout from "./LreReactLayout"

const DateFieldExample = props => {
  const [value, setValue] = useState("2020-02-28")

  const handleChange = event => {
    const newValue = event.target.value
    setValue(newValue)
  }

  return (
    <LreReactLayout>
      <DatePicker
        name="standard_date_picker"
        label="Standard"
        value={value}
        onChange={handleChange}
      />
      <DatePicker
        name="filled_date_picker"
        label="Filled"
        value={value}
        variant="filled"
        onChange={handleChange}
      />
      <DatePicker
        name="outlined_date_picker"
        label="Outlined"
        value={value}
        variant="outlined"
        onChange={handleChange}
      />
      <DatePicker
        name="full_width_date_picker"
        label="Full Width"
        value={value}
        fullWidth
        onChange={handleChange}
      />
    </LreReactLayout>
  )
}

export default DateFieldExample
